import styled from 'styled-components';
import * as React from 'react';

// Components.
import Box, { IBoxProps } from '../Box';
import Grid, { IGridProps } from '../Grid';

// Utils.
import { fadeIn, fadeInRight } from '../../../utils/animations';
import { hexToRgb } from '../../../utils/colors';

/**
 * Container for content side `SideSheet`.
 */
export const Container = styled(Box)<IBoxProps>`
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  animation: ${fadeInRight} 0.3s cubic-bezier(0, 0, 0.2, 1);
  ${({ theme }) => `
    z-index: ${theme.zIndices[2]};
    padding-top: 64px;

    @media screen and (min-width: ${theme.breakpoints.sm}) {
      left: auto;
      bottom: auto;
      width: auto;
    }
  `}
`;

/**
 * Overlay that covers content underneath `SideSheet`.
 */
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  animation: ${fadeIn} 0.3s cubic-bezier(0, 0, 0.2, 1);
  ${({ theme }) => `
  z-index: ${theme.zIndices[2]};
  /* 50% of primary.0 */
  background-color: ${hexToRgb(theme.colors.grayScale[theme.colors.grayScale.length-1], 0.5)};
  `}
`;

/**
 * Box container which houses the close icon for `SideSheet.
 */
export const CloseBox = styled(Grid)<
  IGridProps & React.HTMLProps<HTMLDivElement>
>`
  appearance: none;
  border: none;
  transition: all 0.1s ease-in;
  ${({ theme }) => `
    top: ${theme.space[4]}px;
    right: ${theme.space[4]}px;

    @media screen and (min-width: ${theme.breakpoints.sm}) {
      top: ${theme.space[5]}px;
      right: ${theme.space[5]}px;
    }

    & > svg {
        font-size: 41px;
    }
  `}

  &:hover {
    cursor: pointer;
  }
`;

/**
 * Container for all scrollable content inside `SideSheet`.
 */
export const ScrollableContent = styled(Box)`
  overflow: auto;
  width: 100%;
  height: calc(100vh - 64px);

  ${({ theme }) => `
    @media screen and (min-width: ${theme.breakpoints.sm}) {
      width: 500px;
    }
  `}
`;
